export default "__VITE_ASSET__ff465a5c__"